<h2>Microsoft 365 Email Tests</h2>

<div class="actions">
  <button mat-raised-button color="primary" (click)="triggerDryRun()" [disabled]="loadingDryRun">
    {{ loadingDryRun ? 'Checking...' : 'Auth Dry-Run' }}
  </button>
  <div class="result" *ngIf="dryRunResult">
    <pre>{{ dryRunResult | json }}</pre>
  </div>
</div>

<mat-form-field class="send-to" appearance="outline">
  <mat-label>Recipients (comma separated)</mat-label>
  <input [(ngModel)]="sendTo" matInput placeholder="user@example.com, other@example.com">
</mat-form-field>

<button mat-raised-button color="accent" (click)="sendTestEmail()" [disabled]="loadingSend">
  {{ loadingSend ? 'Sending...' : 'Send Test Email' }}
</button>

<div class="result" *ngIf="sendResult">
  <pre>{{ sendResult | json }}</pre>
</div>
